import React from 'react';
import { Route } from 'react-router-dom';
import {ConnectedRouter} from 'connected-react-router';
import { CSSTransition, SwitchTransition } from 'react-transition-group';
import userActions from "./redux/user/actions";
// @ts-ignore
import Switch from 'react-router-transition-switch';
import Loadable from 'react-loadable';
import { connect } from 'react-redux';

// import routers config
import {
    ROUTE_DASHBOARD,
    ROUTE_REGISTER,
    ROUTE_LOGIN,
    ROUTE_FORGOT_PASSWORD,
    ROUTE_RESET_PASSWORD,
    // ROUTE_USERS_LIST,
    ROUTE_WORKSPACES_LIST,
    ROUTE_PROFILE_EDIT,
    ROUTE_ACTIVE_WORKSPACES_DETAILS,
    ROUTE_WORKSPACE_DETAIL,
    ROUTE_CONTACT_TYPE_LIST,
    ROUTE_ADDRESS_TYPE_LIST,
    ROUTE_ADDRESS_TYPE_CREATE,
    ROUTE_COUNTRY_LIST,
    ROUTE_CONSENTS,
    ROUTE_CONSENT_CREATE,
    ROUTE_CONSENT_EDIT,
    ROUTE_EMPLOYEE_DOCUMENT_TYPE_CREATE,
    ROUTE_EMPLOYEE_DOCUMENT_TYPE_LIST,
    ROUTE_ROUTES,
    ROUTE_DEVICES,
    ROUTE_DEVICES_DETAILS,
    ROUTE_DRIVERS,
    ROUTE_DRIVERS_DETAILS,
    ROUTE_VEHICLES,
    ROUTE_VEHICLES_DETAILS,
    ROUTE_TELEMETRY,
    ROUTE_ROUTE_REPORT,
    ROUTE_POI,
    ROUTE_STATISTICS,
    ROUTE_WORKSPACE_CREATE,
    ROUTE_WORKSPACE_BLOCKED,
    ROUTE_ECODRIVING,
    ROUTE_INVOICES,
    ROUTE_INVOICES_DETAILS,
    ROUTE_INVOICE,
    ROUTE_TARIFF_LIST,
    ROUTE_TARIFF_LOGS,
    ROUTE_PAYMENT_LOGS,
    ROUTE_INVOICE_AFTER_PAY
} from "./config/routes";

// import layout
import Layout from "./layouts";
import Loader from "./components/layout/Loader/Loader";
import NotFoundPage from './pages/system/404';

// import types
import { RouterTypeProps } from "./router.type";
import {ReducerType} from "./redux/reducer.type";
import {getSessionSuperAdminWorkspace} from "./utils/utils";

// @ts-ignore
const loadable = loader => {
    return Loadable({
        loader,
        delay: false,
        loading: () => <Loader fullScreen spinning/>,
    });
};

const routes = [
    {
        path: ROUTE_DASHBOARD,
        Component: loadable(() => import('./pages/dashboard')),
        exact: true,
    },
    {
        path: ROUTE_REGISTER(),
        Component: loadable(() => import('./pages/system/register')),
        exact: true,
    },
    {
        path: ROUTE_LOGIN,
        Component: loadable(() => import('./pages/system/login')),
        exact: true,
    },
    {
        path: ROUTE_FORGOT_PASSWORD,
        Component: loadable(() => import('./pages/system/forgot-password')),
        exact: true,
    },
    {
        path: ROUTE_RESET_PASSWORD,
        Component: loadable(() => import('./pages/system/reset-password')),
        exact: true,
    },
    // {
    //     path: ROUTE_USERS_LIST,
    //     Component: loadable(() => import('./pages/users_workspaces/users_list')),
    //     exact: true,
    // },
    {
        path: ROUTE_WORKSPACES_LIST,
        Component: loadable(() => import('./pages/users_workspaces/workspaces_list')),
        exact: true,
    },
    {
        path: ROUTE_PROFILE_EDIT,
        Component: loadable(() => import('./pages/users_workspaces/profile_edit')),
        exact: true,
    },
    {
        path: ROUTE_ACTIVE_WORKSPACES_DETAILS,
        Component: loadable(() => import('./pages/workspace_details')),
        // Component: loadable(() => import('./pages/users_workspaces/workspace_details')),
        exact: true,
    },
    {
        path: ROUTE_WORKSPACE_DETAIL(),
        Component: loadable( () => import('./pages/workspace_details')),
        exact: true
    },
    {
        path: ROUTE_CONTACT_TYPE_LIST,
        Component: loadable( () => import('./pages/dictionaries/contact_type/list')),
        exact: true
    },
    {
        path: ROUTE_ADDRESS_TYPE_LIST,
        Component: loadable( () => import('./pages/dictionaries/address_types/show_address_types')),
        exact: true
    },
    {
        path: ROUTE_ADDRESS_TYPE_CREATE,
        Component: loadable( () => import('./pages/dictionaries/address_types/create_address_type')),
        exact: true
    },
    {
        path: ROUTE_COUNTRY_LIST,
        Component: loadable(() => import("./pages/dictionaries/countries/show_countries")),
        exact: true
    },
    {
        path: ROUTE_CONSENTS,
        Component: loadable(() => import('./pages/dictionaries/consent_types')),
        exact: true,
    },
    {
        path: ROUTE_CONSENT_CREATE,
        Component: loadable(() => import('./pages/dictionaries/consent_types/create')),
        exact: true,
    },
    {
        path: ROUTE_CONSENT_EDIT(),
        Component: loadable(() => import('./pages/dictionaries/consent_types/edit')),
        exact: true,
    },
    {
        path: ROUTE_EMPLOYEE_DOCUMENT_TYPE_CREATE,
        Component: loadable(() => import('./pages/dictionaries/employee-document-type/create/employee-document-type-create')),
        exact: true,
    },
    {
        path: ROUTE_EMPLOYEE_DOCUMENT_TYPE_LIST,
        Component: loadable(() => import('./pages/dictionaries/employee-document-type/list/employee-document-type-list')),
        exact: true,
    },
    {
        path: ROUTE_ROUTES,
        Component: loadable(() => import("./pages/routes")),
        exact: true
    },
    {
        path: ROUTE_DEVICES,
        Component: loadable(() => import("./pages/devices")),
        exact: true
    },
    {
        path: ROUTE_DEVICES_DETAILS(),
        Component: loadable(() => import("./pages/devices/details")),
        exact: true
    },
    // {
    //     path: ROUTE_CUSTOMERS,
    //     Component: loadable(() => import("./pages/customer")),
    //     exact: true
    // },
    // {
    //     path: ROUTE_CUSTOMERS_DETAILS(),
    //     Component: loadable(() => import("./pages/customer/details")),
    //     exact: true
    // },
    {
        path: ROUTE_DRIVERS,
        Component: loadable(() => import("./pages/drivers")),
        exact: true
    },
    {
        path: ROUTE_DRIVERS_DETAILS(),
        Component: loadable(() => import("./pages/drivers/details")),
        exact:true
    },
    {
        path: ROUTE_VEHICLES,
        Component: loadable(() => import("./pages/vehicles")),
        exact: true
    },
    {
        path: ROUTE_VEHICLES_DETAILS(),
        Component: loadable(() => import("./pages/vehicles/details")),
        exact:true
    },
    {
        path: ROUTE_TELEMETRY,
        Component: loadable(() => import("./pages/telemetry")),
        exact: true
    },
    {
        path: ROUTE_ROUTE_REPORT,
        Component: loadable(() => import("./pages/route-report")),
        exact: true
    },
    {
        path: ROUTE_POI,
        Component: loadable(() => import("./pages/user_poi")),
        exact: true
    },
    {
        path: ROUTE_STATISTICS,
        Component: loadable(() => import("./pages/statistics")),
        exact: true
    },
    {
        path: ROUTE_WORKSPACE_CREATE,
        Component: loadable(() => import("./pages/users_workspaces/workspace_create")),
        exact: true
    },
    {
        path: ROUTE_WORKSPACE_BLOCKED,
        Component: loadable(() => import("./pages/system/blocked")),
        exact: true
    },
    {
        path: ROUTE_ECODRIVING,
        Component: loadable(() => import("./pages/ecodriving")),
        exact: true
    },
    {
        path: ROUTE_INVOICES(),
        Component: loadable(() => import("./pages/invoices")),
        exact: true
    },
    {
        path: ROUTE_INVOICE,
        Component: loadable(() => import("./pages/invoices")),
        exact: true
    },
    {
        path: ROUTE_INVOICE_AFTER_PAY(),
        Component: loadable(() => import("./pages/invoices/afterPay")),
        exact: true
    },
    {
        path: ROUTE_INVOICES_DETAILS(),
        Component: loadable(() => import("./pages/invoices/details")),
        exact:true
    },
    {
        path: ROUTE_TARIFF_LIST,
        Component: loadable(() => import("./pages/tariff/list")),
        exact: true
    },
    {
        path: ROUTE_TARIFF_LOGS,
        Component: loadable(() => import("./pages/tariff/logs")),
        exact: true
    },
    {
        path: ROUTE_PAYMENT_LOGS,
        Component: loadable(() => import("./pages/payment")),
        exact: true
    },

];

const mapStateToProps = (state: ReducerType) =>({ is_super_admin: state.user.is_super_admin, settings: state.settings });

class Router extends React.Component<RouterTypeProps, {}> {

    componentDidMount(): void {
        if (sessionStorage.getItem("superAdminWorkspace")){
            this.props.dispatch({
                type: userActions.CHANGE_ACTIVE_WORKSPACE,
                payload: getSessionSuperAdminWorkspace()
            })
        }
        // if (validateLocalStorage("access_token")){
        //     console.log(localStorage.getItem("access_token"), "local");
        //     // axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem("access_token")}`;
        //     // @ts-ignore
        //     localStorage.setItem("access_token", sessionStorage.getItem("access_token"))
        // }
    }

    componentDidUpdate(prevProps: Readonly<RouterTypeProps>, prevState: Readonly<{}>, snapshot?: any): void {
        if((prevProps.is_super_admin !== this.props.is_super_admin) && this.props.is_super_admin){
            sessionStorage.setItem("superAdmin", `${this.props.is_super_admin}`);
            localStorage.setItem("superAdmin", `${this.props.is_super_admin}`)
        }
    }

    render(): React.ReactElement<any, string | React.JSXElementConstructor<any>> | string | number | {} | React.ReactNodeArray | React.ReactPortal | boolean | null | undefined {
        const {
            history,
            settings: { routerAnimation },
        } = this.props;
        return (
            <ConnectedRouter history={history}>
                <Layout>
                    <Switch
                        render={(props: { children: React.Component; location: { pathname: string; }; }) => {
                            const {
                                children,
                                location: { pathname },
                            } = props;
                            return (
                                <SwitchTransition>
                                    <CSSTransition
                                        key={pathname}
                                        classNames={routerAnimation}
                                        timeout={routerAnimation === 'none' ? 0 : 300}
                                    >
                                        {children}
                                    </CSSTransition>
                                </SwitchTransition>
                            )
                        }}
                  >
                        {routes.map(({ path, Component, exact }) => (
                            <Route path={path} key={path} exact={exact}>
                                {
                                    // @ts-ignore
                                    <Component admin={this.props.is_super_admin} />
                                }
                            </Route>
                        ))}
                        <Route component={NotFoundPage} />
                    </Switch>
                </Layout>
            </ConnectedRouter>
        );
    }
}

export default connect(mapStateToProps)(Router);
